var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound44C = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 85 85",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M36.375 23.5a2 2 0 0 1 .164-2.976l5.327-4.26 26.163 26.162L41.866 68.59l-5.327-4.26a2 2 0 0 1-.164-2.976L55.3 42.425 36.375 23.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M41.866 14.85a1 1 0 0 1 1.414 0l26.163 26.162a2 2 0 0 1 0 2.829L43.28 70.004a1 1 0 1 1-1.414-1.415l26.163-26.163-26.163-26.163a1 1 0 0 1 0-1.414Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M23.48 34.648c-4.295 4.296-4.295 11.26 0 15.557 4.297 4.295 11.261 4.295 15.557 0 4.296-4.296 4.296-11.261 0-15.557-4.296-4.296-11.26-4.296-15.556 0Z"
})));
SvgRound44C.viewBox = '0 0 85 85';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound44C);
export default ForwardRef;